import { Alert, Box } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import {
  RegistrationCreateDto,
} from "../../openapi/edsn-webapi";
import { safePropertyMap } from "../../utils";
import { phoneValidator } from "../../validators";
import { InputControl } from "../common";
import ContactWithPhonePropType from "./ContactWithPhonePropType";

type ContactControlProps = {
  fieldname: ContactWithPhonePropType;
};

const ContactControl = ({ fieldname }: ContactControlProps) => {
  const map = safePropertyMap<RegistrationCreateDto>();
  const intl = useIntl();
  const { trigger } = useFormContext<RegistrationCreateDto>();
  const showInfo = fieldname === "contactDefault";
  const firstNameField = map(`${fieldname}.initials`);

  return (
    <Box sx={{ position: "relative" }}>
      {showInfo && (
        <Alert severity="info">
          <FormattedMessage id="contactDetailsInformation" />
        </Alert>
      )}
      <InputControl
        required
        label="firstname"
        name={firstNameField}
        validate={(value) =>
          !value || value.length <= 16 || "firstNameMaxLength"
        }
        onChange={(onChange) => (event) => {
          onChange(event);
          void trigger(firstNameField);
        }}
      />
      <InputControl
        required
        label="lastname"
        name={map(`${fieldname}.lastName`)}
      />
      <InputControl
        required
        pattern={{
          value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
          message: intl.formatMessage({ id: "invalidEmailAddress" }),
        }}
        type="email"
        label="email"
        name={map(`${fieldname}.emailAddress`)}
      />
      <InputControl
        required
        validate={phoneValidator}
        placeholder="+31612345678"
        label="phoneNumber"
        name={map(`${fieldname}.telephone`)}
      />
    </Box>
  );
};

export default ContactControl;
